import * as api from '../api';

const routes = [
  "carto.link.entity",
  "carto.geo.entity",
  "explore.entity",
  "explore.theme.custom_map.entity"
].flatMap(parent_route => [
  {
      name: parent_route + ".briefing",
      path: '/briefing',
      title: "Profil",
    },
    {
      name: parent_route + ".description",
      path: '/description',
      title: "Profil",
    },
    {
      name: parent_route + ".reseaux",
      path: '/reseaux',
      title: "Profil",
    },
    {
      name: parent_route + ".entities",
      path: '/entities',
      title: "Profil",
    },
    {
      name: parent_route + ".themes",
      path: '/themes',
      title: "Profil",
      onActivate: [{
          k: "focus_theme",
          cb: () => api.getFocusTheme().then(d => ({ focus_theme: d })),
      },{
          k: "themes",
          cb: () => api.getAllTheme().then(d => ({ themes: d })),
      }]
    },
    {
      name: parent_route + ".twitter",
      path: '/twitter',
      title: "Profil",
    },
    {
      name: parent_route + ".facebook",
      path: '/facebook',
      title: "Profil",
    },
  {
    name: parent_route + ".linkedin",
    path: '/linkedin',
    title: "Profil",
  },
]);

export default routes;
